export default __webpack_public_path__ + "static/media/dr-vaidyas.d3b057e6.jpg";